import type { MangaArticle } from '@/pages/article/types';

export const categories: { slug: string; name: string; description: string }[] = [
  { slug: 'all', name: '全部', description: '浏览全部bl漫画推荐作品' },
  { slug: 'tian-chong', name: '甜宠', description: '甜蜜宠溺的bl漫画，温暖治愈的爱情故事' },
  { slug: 'nue-xin', name: '虐心', description: '虐心催泪的bl漫画，情感纠葛深入人心' },
  { slug: 'gu-feng', name: '古风', description: '古风bl漫画，穿越时空的唯美爱情' },
  { slug: 'xian-dai', name: '现代', description: '现代都市bl漫画，贴近生活的浪漫故事' },
  { slug: 'ke-huan', name: '科幻', description: '科幻题材bl漫画，未来世界的奇幻爱情' },
  { slug: 'xiao-yuan', name: '校园', description: '校园bl漫画，青春纯爱的美好时光' },
  { slug: 'xuan-yi', name: '悬疑', description: '悬疑推理bl漫画，紧张刺激的剧情发展' },
  { slug: 'qi-huan', name: '奇幻', description: '奇幻题材bl漫画，异世界的冒险与爱情' },
];

export const mangaArticles: MangaArticle[] = [
  {
    id: 1,
    title: '春日限定',
    slug: 'chun-ri-xian-ding',
    category: '甜宠',
    categorySlug: 'tian-chong',
    rating: 9.2,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20BL%20manga%20style%20illustration%20of%20two%20young%20men%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20anime%20art%20style%2C%20gentle%20expressions%2C%20falling%20petals&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    description: '一段始于春日的温暖邂逅，两个少年在樱花树下相遇，从陌生到相知，从相知到相爱。这是一部充满治愈力量的甜宠bl漫画，画风细腻，情节温馨感人。',
    author: '樱之物语',
    status: '已完结',
    updateDate: '2026-08-01',
    tags: ['甜宠', '治愈', '校园', '完结'],
    contentHtml: '<p>《春日限定》是一部以校园为背景的甜宠bl漫画...</p>',
    viewCount: 158000,
    commentCount: 3200,
  },
  {
    id: 2,
    title: '深渊之眼',
    slug: 'shen-yuan-zhi-yan',
    category: '虐心',
    categorySlug: 'nue-xin',
    rating: 8.8,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20BL%20manga%20illustration%20with%20two%20men%20in%20dramatic%20shadow%20and%20light%2C%20deep%20emotional%20expression%2C%20gothic%20undertones%2C%20dark%20blue%20and%20deep%20red%20accents%2C%20anime%20art%20style%2C%20intense%20eye%20contact%2C%20mysterious%20mood&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    description: '当深渊凝视你时，你也凝视着深渊。一场意外让两个本无交集的灵魂纠缠在一起，爱恨交织的命运之轮开始转动。虐心催泪的情感深度，让人无法自拔。',
    author: '夜幕行者',
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['虐心', '悬疑', '都市', '连载'],
    contentHtml: '<p>《深渊之眼》是一部融合悬疑与虐心元素的bl漫画...</p>',
    viewCount: 232000,
    commentCount: 5600,
  },
  {
    id: 3,
    title: '长安幻夜',
    slug: 'chang-an-huan-ye',
    category: '古风',
    categorySlug: 'gu-feng',
    rating: 9.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20BL%20manga%20style%2C%20two%20handsome%20men%20in%20traditional%20Tang%20dynasty%20robes%2C%20lantern%20lit%20ancient%20palace%20courtyard%20at%20night%2C%20flowing%20long%20hair%2C%20romantic%20moonlit%20scene%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20anime%20art%20style&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    description: '大唐盛世，长安城中一段跨越身份与世俗的绝美爱恋。将军与文人，金戈铁马与诗词歌赋的碰撞。古风bl漫画中的巅峰之作，画面精美绝伦。',
    author: '长安画师',
    status: '已完结',
    updateDate: '2026-07-28',
    tags: ['古风', '历史', '权谋', '完结'],
    contentHtml: '<p>《长安幻夜》以盛唐为背景的古风bl漫画...</p>',
    viewCount: 345000,
    commentCount: 8900,
  },
  {
    id: 4,
    title: '都市夜话',
    slug: 'du-shi-ye-hua',
    category: '现代',
    categorySlug: 'xian-dai',
    rating: 8.6,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20urban%20BL%20manga%20illustration%2C%20two%20stylish%20young%20men%20in%20city%20night%20setting%2C%20neon%20lights%20reflecting%20on%20glass%20buildings%2C%20casual%20contemporary%20fashion%2C%20warm%20cafe%20lighting%2C%20anime%20art%20style%2C%20relaxed%20and%20intimate%20atmosphere&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    description: '在繁华都市的霓虹灯下，两个普通上班族的故事。没有惊天动地，只有日常的温暖陪伴。现代bl漫画中贴近生活的佳作，让人感同身受。',
    author: '城市漫步',
    status: '已完结',
    updateDate: '2026-07-20',
    tags: ['现代', '都市', '日常', '完结'],
    contentHtml: '<p>《都市夜话》描绘了两个都市青年的日常爱情...</p>',
    viewCount: 189000,
    commentCount: 4100,
  },
  {
    id: 5,
    title: '星海迷途',
    slug: 'xing-hai-mi-tu',
    category: '科幻',
    categorySlug: 'ke-huan',
    rating: 9.0,
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20BL%20manga%20illustration%2C%20two%20young%20men%20in%20futuristic%20space%20suits%20against%20a%20starry%20galaxy%20backdrop%2C%20cosmic%20nebula%20colors%2C%20spaceship%20interior%20with%20holographic%20displays%2C%20anime%20art%20style%2C%20dreamy%20and%20mysterious%20atmosphere&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    description: '在浩瀚宇宙的星际航行中，一个机械师和一个领航员的故事。当飞船迷失在未知星系，两颗孤独的心在星海中找到了彼此。',
    author: '星河旅人',
    status: '连载中',
    updateDate: '2026-08-04',
    tags: ['科幻', '星际', '冒险', '连载'],
    contentHtml: '<p>《星海迷途》背景设定在遥远的未来...</p>',
    viewCount: 201000,
    commentCount: 4800,
  },
  {
    id: 6,
    title: '花间集',
    slug: 'hua-jian-ji',
    category: '古风',
    categorySlug: 'gu-feng',
    rating: 9.3,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20ancient%20Chinese%20BL%20manga%20with%20two%20scholars%20in%20traditional%20Song%20dynasty%20robes%20in%20a%20flower%20garden%2C%20peony%20blooms%20everywhere%2C%20elegant%20brush%20painting%20aesthetic%2C%20soft%20pastel%20colors%2C%20anime%20art%20style%2C%20poetic%20and%20refined%20atmosphere&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    description: '以花为媒，以诗传情。两位才子在花间雅集上相识，从此诗词唱和，情愫暗生。画面如同工笔画般精美，古风bl漫画的瑰宝。',
    author: '花间词人',
    status: '已完结',
    updateDate: '2026-07-15',
    tags: ['古风', '文人', '诗词', '完结'],
    contentHtml: '<p>《花间集》是一部极致唯美的古风bl漫画...</p>',
    viewCount: 298000,
    commentCount: 7200,
  },
  {
    id: 7,
    title: '雨季不再来',
    slug: 'yu-ji-bu-zai-lai',
    category: '校园',
    categorySlug: 'xiao-yuan',
    rating: 8.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Youthful%20BL%20manga%20illustration%20of%20two%20high%20school%20boys%20sharing%20an%20umbrella%20in%20rain%2C%20school%20uniforms%2C%20cherry%20blossom%20trees%20along%20path%2C%20soft%20rainy%20day%20atmosphere%2C%20gentle%20warm%20light%2C%20anime%20art%20style%2C%20nostalgic%20and%20sweet&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    description: '青春是一场下不完的雨，而你是我雨季里唯一的阳光。高中校园里，两个少年从陌生同桌到形影不离，青涩而美好的初恋故事。',
    author: '雨季少年',
    status: '已完结',
    updateDate: '2026-07-10',
    tags: ['校园', '青春', '治愈', '完结'],
    contentHtml: '<p>《雨季不再来》是一部温暖治愈的校园bl漫画...</p>',
    viewCount: 176000,
    commentCount: 3900,
  },
  {
    id: 8,
    title: '暗夜追踪',
    slug: 'an-ye-zhui-zong',
    category: '悬疑',
    categorySlug: 'xuan-yi',
    rating: 9.1,
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20BL%20manga%20illustration%2C%20two%20detectives%20in%20trench%20coats%20under%20streetlight%20at%20night%2C%20rain-slicked%20city%20streets%2C%20noir%20atmosphere%2C%20intense%20dramatic%20lighting%2C%20anime%20art%20style%2C%20suspenseful%20mood&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    description: '一桩离奇案件将刑警与私家侦探的命运交织在一起。在追查真相的过程中，两人从互相猜忌到彼此信任。悬疑与爱情完美融合。',
    author: '真相追踪者',
    status: '连载中',
    updateDate: '2026-08-03',
    tags: ['悬疑', '推理', '都市', '连载'],
    contentHtml: '<p>《暗夜追踪》是一部紧张刺激的悬疑推理bl漫画...</p>',
    viewCount: 267000,
    commentCount: 6300,
  },
  {
    id: 9,
    title: '暖阳之下',
    slug: 'nuan-yang-zhi-xia',
    category: '甜宠',
    categorySlug: 'tian-chong',
    rating: 8.7,
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20BL%20manga%20illustration%2C%20two%20young%20men%20cooking%20together%20in%20a%20sunlit%20kitchen%2C%20golden%20afternoon%20light%20streaming%20through%20windows%2C%20domestic%20bliss%20atmosphere%2C%20anime%20art%20style%2C%20soft%20and%20heartwarming&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    description: '没有什么比在暖阳下和喜欢的人一起做饭更幸福的事了。两个合租室友从互不相识到日久生情，甜到让人牙疼的日常故事。',
    author: '暖阳烘焙',
    status: '已完结',
    updateDate: '2026-06-28',
    tags: ['甜宠', '日常', '同居', '完结'],
    contentHtml: '<p>《暖阳之下》是一部温暖人心的甜宠bl漫画...</p>',
    viewCount: 145000,
    commentCount: 2800,
  },
  {
    id: 10,
    title: '浮生若梦',
    slug: 'fu-sheng-ruo-meng',
    category: '古风',
    categorySlug: 'gu-feng',
    rating: 9.4,
    coverImage: 'https://readdy.ai/api/search-image?query=Ethereal%20ancient%20Chinese%20BL%20manga%2C%20two%20immortals%20in%20flowing%20white%20and%20blue%20robes%20floating%20among%20clouds%20and%20misty%20mountains%2C%20celestial%20palace%20in%20distance%2C%20watercolor%20wash%20aesthetic%2C%20anime%20art%20style%2C%20dreamlike%20and%20transcendent&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    description: '仙君与凡人的宿世情缘，轮回千年的等待。当记忆的封印被解开，那段被遗忘的过往缓缓浮现。画风空灵唯美，令人沉醉。',
    author: '浮生绘卷',
    status: '已完结',
    updateDate: '2026-06-20',
    tags: ['古风', '仙侠', '轮回', '完结'],
    contentHtml: '<p>《浮生若梦》融合了仙侠与轮回元素的古风bl漫画...</p>',
    viewCount: 312000,
    commentCount: 7800,
  },
  {
    id: 11,
    title: '心跳频率',
    slug: 'xin-tiao-pin-lv',
    category: '现代',
    categorySlug: 'xian-dai',
    rating: 8.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Contemporary%20BL%20manga%20illustration%2C%20two%20office%20workers%20in%20business%20attire%20sharing%20earphones%20on%20a%20rooftop%20at%20sunset%2C%20city%20skyline%20background%2C%20warm%20orange%20and%20pink%20evening%20light%2C%20anime%20art%20style%2C%20romantic%20urban%20setting&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    description: '在同一家公司工作的两人，因为一副耳机产生了奇妙的交集。在都市的喧嚣中，找到属于彼此的频率。现代bl漫画中的清新之作。',
    author: '城市频率',
    status: '连载中',
    updateDate: '2026-08-02',
    tags: ['现代', '职场', '音乐', '连载'],
    contentHtml: '<p>《心跳频率》讲述了两个职场青年的爱情故事...</p>',
    viewCount: 134000,
    commentCount: 2500,
  },
  {
    id: 12,
    title: '月光边境',
    slug: 'yue-guang-bian-jing',
    category: '奇幻',
    categorySlug: 'qi-huan',
    rating: 9.2,
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20BL%20manga%20illustration%2C%20two%20men%20one%20as%20a%20werewolf%20and%20one%20as%20a%20vampire%20under%20full%20moon%2C%20mystical%20forest%20setting%20with%20glowing%20elements%2C%20silver%20moonlight%2C%20anime%20art%20style%2C%20ethereal%20and%20enchanting%20atmosphere&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    description: '在人类与异族共存的平行世界，一个狼人与一个吸血鬼的禁忌之恋。月光下的边境地带，是唯一能让他们自由相爱的地方。',
    author: '月光旅人',
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['奇幻', '异族', '冒险', '连载'],
    contentHtml: '<p>《月光边境》构建了一个宏大的奇幻世界...</p>',
    viewCount: 221000,
    commentCount: 5400,
  },
];

export const siteInfo = {
  name: 'BL漫画精选',
  tagline: '最新最全BL漫画在线阅读平台',
  description: 'BL漫画精选致力于为BL爱好者打造专属阅读平台，精选高分bl漫画作品推荐，涵盖甜宠、虐心、古风、现代等多种题材。每日更新最新bl漫画，免费在线畅读优质bl漫画内容。',
  established: '2023年',
  email: 'contact@blmanga-select.com',
  socialLinks: {
    weibo: 'https://weibo.com/blmanga',
    wechat: 'blmanga_select',
    bilibili: 'https://bilibili.com/blmanga',
  },
  stats: {
    totalWorks: 5000,
    monthlyActive: 120000,
    avgRating: 8.8,
    dailyUpdates: 30,
  },
};

export const testimonials = [
  {
    id: 1,
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20profile%20picture%2C%20pink%20hair%2C%20soft%20smile%2C%20pastel%20background%2C%20simple%20anime%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '这个网站真的太棒了！分类清晰，推荐精准，我找到了好多好看的bl漫画。每天都会上来看看有没有更新，已经推荐给身边所有同好了！',
    date: '2026-07-15',
  },
  {
    id: 2,
    name: '夜雨声烦',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20boy%20avatar%20profile%20picture%2C%20dark%20hair%2C%20cool%20expression%2C%20simple%20background%2C%20anime%20art%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为bl漫画资深读者，这里的作品质量非常高。评分系统很靠谱，高分的作品确实都很好看。古风分类是我最喜欢的板块。',
    date: '2026-07-20',
  },
  {
    id: 3,
    name: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20girl%20avatar%20profile%20picture%2C%20blue%20hair%2C%20cheerful%20smile%2C%20bright%20background%2C%20anime%20art%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '页面设计很好看，阅读体验也很流畅。最爱甜宠分类，每一部推荐都戳中我的萌点。希望能一直做下去，会一直支持的！',
    date: '2026-07-25',
  },
];

export const faqData = [
  {
    question: 'bl漫画精选网站上的漫画是免费的吗？',
    answer: '是的，我们网站上的所有bl漫画内容均可免费在线阅读。我们致力于为广大bl爱好者提供优质的免费阅读体验，无需付费即可畅读所有推荐的bl漫画作品。',
  },
  {
    question: '网站上的bl漫画多久更新一次？',
    answer: '我们每日更新最新的bl漫画内容，确保读者能够第一时间看到最新的作品推荐。每周会推出精选专题，每月会更新高分排行榜，持续为bl爱好者带来新鲜内容。',
  },
  {
    question: '如何找到适合自己口味的bl漫画？',
    answer: '您可以通过我们的分类导航，按照甜宠、虐心、古风、现代、科幻、校园、悬疑、奇幻等不同题材进行筛选。每部作品都有详细的评分和标签，帮助您快速找到心仪的bl漫画。',
  },
  {
    question: '评分系统是如何运作的？',
    answer: '我们的评分基于读者评价和编辑团队的专业评审综合得出。满分10分，8分以上即为优秀作品。我们确保评分公正客观，真实反映每部bl漫画的品质水平。',
  },
  {
    question: '可以推荐bl漫画给网站吗？',
    answer: '当然可以！我们非常欢迎读者推荐优秀的bl漫画作品。您可以通过关于我们页面的联系方式，将您推荐的作品信息发送给我们，我们的编辑团队会认真评估每一份推荐。',
  },
];